<script>
export default {
    name: "CookiesRule",
    data() {
        return {
            pa: true,
            marketing: false,
            essential: true,
            isShow: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="cookies_rule" :class="{active: isShow}">
        <div class="in">
            <p>WE USE COOKIES TO PROVIDE YOU WITH A PERSONALISED SHOPPING EXPERIENCE AND IMPROVE OUR SERVICES. IF YOU ARE HAPPY TO OPT-IN, CLICK "ACCEPT”.</p>
            <div class="switch_wrap">
                <div class="switch_group">
                    <div class="item">
                        <div class="text">Web Performance and Analysis</div>
                        <div class="switch" :class="{active: pa}" @click="pa = !pa"></div>
                    </div>
                    <div class="item">
                        <div class="text">Marketing</div>
                        <div class="switch" :class="{active: marketing}" @click="marketing = !marketing"></div>
                    </div>
                    <div class="item">
                        <div class="text">Essential</div>
                        <div class="switch" :class="{active: essential}" @click="essential = !essential"></div>
                    </div>
                </div>
                <div class="btn">Accept All Cookies</div>
            </div>
        </div>
        <div class="btn_close" @click="isShow = false">
            <p>Continue without Accepting</p>
            <div class="icon"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cookies_rule{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #000;
    z-index: 9;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 135px;
    font-size: 12px;
    transform: translate(0, 100%);
    transition: transform .3s;
    &.active{
        transform: translate(0, 0);
    }
    .btn_close{
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .icon{
            width: 20px;
            height: 20px;
            border: 1px solid #fff;
            position: relative;
            margin-left: 10px;
            &::before,
            &::after{
                width: 80%;
                border-bottom: 1px solid #fff;
                content: "";
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
    .in{
        display: flex;
        flex-direction: column;
        .switch_wrap{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 25px;
            .switch_group{
                display: flex;
                align-items: center;
                .item{
                    display: flex;
                    align-items: center;
                    margin-right: 40px;
                    .switch{
                        width: 35px;
                        height: 16px;
                        border-radius: 16px;
                        background: #a0a0a0;
                        margin-left: 10px;
                        position: relative;
                        transition: background-color .3s;
                        cursor: pointer;
                        &::after{
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background: #000;
                            content: "";
                            display: block;
                            position: absolute;
                            top: 1px;
                            left: 1px;
                            transition: left .3s;
                        }
                        &.active{
                            background: #fff;
                            &::after{
                                left: 20px;
                            }
                        }
                    }
                }
            }
            .btn{
                width: 170px;
                height: 32px;
                background: #fff;
                color: #303030;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
    }
}
</style>